import { createAction, createReducer } from '@reduxjs/toolkit';
import { create, get, isEmpty } from 'lodash-es';

const MODULE_PREFIX = "[ MyaccountV2 ]"
const Actions = {
  fetchMyAccount: `${MODULE_PREFIX} fetchMyAccount`,
  updateWhatsAppSubscription: `${MODULE_PREFIX} updateWhatsAppSubscription`,
  fetchEquityAccPreferences: `${MODULE_PREFIX} fetchEquityAccPreferences`,
  updateOrderPreferences: `${MODULE_PREFIX} updateOrderPreferences`,
  setAccountData: `${MODULE_PREFIX} setAccountData`,
  resetAccountData: `${MODULE_PREFIX} resetAccountData`,
  setBankData: `${MODULE_PREFIX} setBankData`,
  setVerifyBankData: `${MODULE_PREFIX} setVerifyBankData`,
  addAdditionalBank: `${MODULE_PREFIX} addAdditionalBank`,
  setMyAccountStorageData: `${MODULE_PREFIX} setMyAccountStorageData`,
  setFreedomPlanData: `${MODULE_PREFIX} setFreedomPlanData`,
  setBanksListMap: `${MODULE_PREFIX} setBanksListMap`, //TODO: CHeck with alekhya for possible duplicate in app.js
  setEquityAccPreferences: `${MODULE_PREFIX} setEquityAccPreferences`,
  setBalanceData: `${MODULE_PREFIX} setBalanceData`,
  fetchBalance:`${MODULE_PREFIX} fetchBalance`,
  getEquitySubscriptionStatus: `${MODULE_PREFIX} getEquitySubscriptionStatus`,
	setEquitySubscriptionStatus: `${MODULE_PREFIX} setEquitySubscriptionStatus`,
};

//actions
export const fetchMyAccount = createAction(Actions.fetchMyAccount);
export const updateWhatsAppSubscription = createAction(Actions.updateWhatsAppSubscription);
export const fetchEquityAccPreferences = createAction(Actions.fetchEquityAccPreferences);
export const updateOrderPreferences = createAction(Actions.updateOrderPreferences);
export const setAccountData = createAction(Actions.setAccountData);
export const resetAccountData = createAction(Actions.resetAccountData);
export const setBanksListMap = createAction(Actions.setBankData);
export const setVerifyBankData = createAction(Actions.setVerifyBankData);
export const addAdditionalBank = createAction(Actions.addAdditionalBank);
export const setMyAccountStorageData = createAction(Actions.setMyAccountStorageData);
export const setFreedomPlanData = createAction(Actions.setFreedomPlanData);
export const setEquityAccPreferences = createAction(Actions.setEquityAccPreferences);
export const fetchBalance = createAction(Actions.fetchBalance);
export const setBalanceData = createAction(Actions.setBalanceData);
export const getEquitySubscriptionStatus = createAction(Actions.getEquitySubscriptionStatus);
export const setEquitySubscriptionStatus = createAction(Actions.setEquitySubscriptionStatus);

//selector
export const getAccountData = (state) => {
  return state.myAccount.accountData;
};

export const getBanksListMap = (state) => {
  return state.myAccount.banksListMap || {};
};

export const getAllBanks = (state) => {
  const mfBanks = get(state, "myAccount.banksListMap.mf", []);
  const equityBanks = get(state, "myAccount.banksListMap.equity", []);

  return mfBanks.concat(equityBanks);
};

export const getBankWithId = (state, bankId) => {
  if (!bankId || isEmpty(state)) return {};

  const bankList = getAllBanks(state);
  return bankList.find(bank => bank.bank_id == bankId);
};

export const getMandatesForBank = (state, bankId) => {
  if (!bankId || isEmpty(state)) return {};

  const banks = get(getAccountData(state), "bank_mandates.banks", null);
  if (!isEmpty(banks)) {
    const bank = banks.find(({ bank_id }) => bank_id == bankId);
    return bank.mandates;
  }

  return [];
}

export const getVerifyBankData = (state) => {
  return state.myAccount.verifyBankData;
};

export const getMyAccountStorage = (state) => {
  return state.myAccount.myAccountStorage;
};

export const getFreedomPlanData = (state) => {
  return state.myAccount.freedomPlanData;
};

export const getEquityAccountPreferences = (state) => {
  return state.myAccount.equityAccPreferences;
};

export const getEquityBalance = (state) =>{
  return state.myAccount.equityBalance
}

export const getEquitySubscriptionData = (state) => {
	const equitySubscriptionStatus = get(state, 'myAccount.equitySubscriptionStatus', {});
	return equitySubscriptionStatus;
};


const initialState = {
  accountData: {},
  banksListMap: {},
  verifyBankData: {},
  myAccountStorage: {},
  freedomPlanData: {},
  equityAccPreferences: {},
  equityBalance: {},
  equitySubscriptionStatus: {},
};

//reducer
export default createReducer(initialState, (builder) => {
  builder.addCase(setAccountData, (state, action) => {
    state.accountData = { ...state.accountData, ...action.payload };
  });
  builder.addCase(resetAccountData, (state, action) => {
    state.accountData = {};
  });
  builder.addCase(setBanksListMap, (state, action) => {
    state.banksListMap = action.payload;
  });
  builder.addCase(setVerifyBankData, (state, action) => {
    state.verifyBankData = { ...state.verifyBankData, ...action.payload };
  });
  builder.addCase(setMyAccountStorageData, (state, action) => {
    state.myAccountStorage = { ...state.myAccountStorage, ...action.payload };
  });
  builder.addCase(setFreedomPlanData, (state, action) => {
    state.equityStatus = { ...state.equityStatus, ...action.payload };
  });
  builder.addCase(setEquityAccPreferences, (state, action) => {
    state.equityAccPreferences = { ...state.equityAccPreferences, ...action.payload };
  });
  builder.addCase(setBalanceData, (state,action) => {
    state.equityBalance ={...state.equityBalance, ...action.payload}
  });
  builder.addCase(setEquitySubscriptionStatus, (state, action) => {
		state.equitySubscriptionStatus = action.payload;
	});
});
